// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"172":"9190d1c9","845":"9a202054"}[chunkId] + ".css";
};